import { render } from "./AppWorkflow.vue?vue&type=template&id=74ca4223&lang=html"
import script from "./AppWorkflow.vue?vue&type=script&lang=js"
export * from "./AppWorkflow.vue?vue&type=script&lang=js"

import exportComponent from "/Users/richken/code/StoryPhonesWebsite/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__